<template>
  <section class="authentication-layout -requerente">
    <div class="content">
      <portal-brand />

      <div class="form">
        <slot name="form-header" />
        <slot name="form-content" />
      </div>

      <nav class="navigation">
        <slot name="navigation" />
      </nav>
    </div>

    <aside class="sidebar">
<!--      <img class="papers"-->
<!--           src="@/assets/image/banner.png"-->
<!--           alt="Licenças, Autorizações e Certificados Ambientais" width="300"/>-->

      <contact-component/>

    </aside>
  </section>
</template>

<script>
import PortalBrand from '@/components/base/PortalBrand';
import ContactComponent from '@/components/ContactComponent';

export default {
  name: 'AuthenticationLayout',
  components: {
    PortalBrand,
    ContactComponent,
  },
  methods: {
    userAlias() {
      return this.$router.history.current.meta.userAlias;
    },
    userType() {
      return this.$router.history.current.meta.userType;
    },
  },
};
</script>

<style lang="scss">
.authentication-layout {
  &.-requerente {
    display: grid;
    grid-template-areas: "content sidebar";
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    height: 100vh;
    overflow: hidden;

    > .sidebar {
      display: flex;
    }
  }

  > .content {
    & {
      grid-area: content;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 2rem 0 1rem;
      background: #fff;
    }

    > .form {
      & {
        width: 360px;
      }

      > .header {
        text-align: center;

        .icon.-colour {
          margin-bottom: 2rem;
        }
      }

      > .card > .action {
        justify-content: space-around;
      }
    }

    > .navigation {
      & {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      > .text {
        color: #7e7e7e;
      }

      > .link {
        & {
          text-transform: none;
        }

        > .text {
          text-decoration: underline;
        }
      }
    }
  }

  > .sidebar {
    & {
      position: relative;
      grid-area: sidebar;
      padding: 2rem;
      display: none;
      flex-direction: flex-end;
      justify-content: flex-end;
      align-items: center;
      background: url('../assets/image/banner.png') no-repeat bottom,
      radial-gradient(ellipse at center, #01c469 0%,#00a85a 65%,#00a558 100%);
      background-size: cover;
    }

    > .papers {
      position: absolute;
      top: 40%;
      left: 55%;
      transform: translate(-50%, -50%);
      max-width: calc(30% + 15rem);
    }

    > .ima-logo {
      align-self: flex-end;
      justify-self: flex-end;
    }
  }
}
</style>
